module.exports = __webpack_public_path__ + "media/images/icons/filled/book-d1474981911dc139e138134c9288db60.svg";